import Uppy from "@uppy/core";
import Dashboard from "@uppy/dashboard";
import XHRUpload from "@uppy/xhr-upload";
import ImageEditor from "@uppy/image-editor";
import Compressor from "./uppy/compressor";

window.setupUppy = function($dispatch, id, uploadEndpoint) {
  let uppy = new Uppy({
    id: id,
    autoProceed: false,
    allowMultipleUploads: true,
    restrictions: {
      allowedFileTypes: ["image/*"],
    },
    debug: true,
  });

  uppy.use(XHRUpload, {
    endpoint: uploadEndpoint,
    limit: 3, // max concurrent uploads
    fieldName: "file", // name of the file field to be sent to the backend
  });

  uppy.use(Dashboard, {
    metaFields: [
      { id: "name", name: "Name", placeholder: "File name" },
      { id: "title", name: "Title", placeholder: "File Title" },
      {
        id: "alt_text",
        name: "Alt text",
        placeholder: "Alternate text. Necessary for accessibility",
      },
    ],
    theme: "auto",
    note: "Upload images only",
  });

  uppy.use(ImageEditor, {
    target: Dashboard,
    quality: 0.8, // for the resulting image, 0.8 is a sensible default
    cropperOptions: {},
  });

  uppy.on("upload-success", (file, response) => {
    // this is the file from the response and not uppy's file object
    $dispatch("file-uploaded", response.body.data);
  });

  uppy.use(Compressor, {
    quality: 0.8,
    limit: 10,
    convertSize: 500,
    maxWidth: 1000,
    maxHeight: 1000,
  });

  uppy.on("upload-error", (file, error, response) => {
    console.log("error with file:", file);
    console.log("error message:", error);
    $dispatch("notify", { msg: "error uploading file", type: "error" });
  });

  return uppy;
};
